// extracted by mini-css-extract-plugin
export default {"wrapper":"as-z","response":"bs-z","error":"cs-z","disabled":"ds-z","buttons":"es-z","feedbackQuestionSection":"fs-z","yesNoWrapper":"gs-z"};